export default __webpack_public_path__ + "static/media/icon-dinning-room.7b621760.svg";